/**
 * Classic T, intermission 4: fireflies in a steel box (docs/spec/03 §2). Two guards circle a bin of
 * diamonds; one boulder waits over the one gap. Drop it as a guard comes up the near side, then
 * raid the bin between the survivor's laps.
 */

import type { CaveDef } from '../types';

export const caveT: CaveDef = {
  id: 'T',
  name: 'LAST SHOT',
  hint: 'One gap, one boulder, two guards. Make it count.',
  intermission: true,
  colors: [2, 14, 7],
  diamondValue: 40,
  extraValue: 60,
  fill: { base: '.', items: [['r', 12], ['d', 10]] },
  levels: [
    { seed: 3101, diamonds: 10, time: 35 },
    { seed: 3102, diamonds: 12, time: 32 },
    { seed: 3103, diamonds: 13, time: 29 },
    { seed: 3104, diamonds: 14, time: 26 },
    { seed: 3105, diamonds: 16, time: 24 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WP.????????????????W',
    'W..??????????WrW???W',
    'W..??????????...???W',
    'W???WWWWWWWWWW W???W',
    'W???W   f      W???W',
    'W???W wddddddw W???W',
    'W???W wddddddw W???W',
    'W???W wwwwwwww W???W',
    'W???W      F   W???W',
    'W???WWWWWWWWWWWW??XW',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
